import { useCallback } from 'react';
import LocalAccountsTableFilters from './LocalAccountsTableFilters';
import LocalAccountsSearch from './LocalAccountsSearch';
import { useLocalAccounts } from '../../../../context/LocalAccountsContext';

const LocalAccountsToolbar = () => {
    const { setFilters, filters } = useLocalAccounts();

    const handleSearchChange = useCallback((newSearch: string) => {
        setFilters(({ search, ...prevFilters }) => {
            if (newSearch) {
                return {
                    ...prevFilters,
                    search: newSearch
                };
            }

            return prevFilters;
        });
    }, [setFilters]);

    return <div className="flex justify-between h-8">
        <LocalAccountsTableFilters />
        <LocalAccountsSearch onSearchChange={handleSearchChange} search={filters.search ?? ''} />
    </div>;
};
export default LocalAccountsToolbar;